import * as React from 'react'

export const BoldCheckmarkIcon = ({
  size = 20,
  ...props
}: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) => (
  <svg width={size} height={(size * 8) / 10} fill="none" viewBox="0 0 10 8" {...props}>
    <path
      d="M3.82919 7.61528C3.73373 7.71129 3.6035 7.76486 3.46821 7.76486C3.33293 7.76486 3.20269 7.71129 3.10724 7.61528L0.224383 4.73196C-0.0747943 4.43278 -0.0747943 3.94764 0.224383 3.64903L0.585359 3.28796C0.88463 2.98878 1.3692 2.98878 1.66838 3.28796L3.46821 5.08788L8.33162 0.224383C8.63089 -0.0747943 9.11593 -0.0747943 9.41464 0.224383L9.77562 0.585452C10.0748 0.88463 10.0748 1.36967 9.77562 1.66838L3.82919 7.61528Z"
      fill="currentColor"
    />
  </svg>
)

export default BoldCheckmarkIcon
